import React from 'react';
interface SectionProps {
  title?: string;
  children: React.ReactNode;
  className?: string;
}
export const Section: React.FC<SectionProps> = ({
  title,
  children,
  className = ''
}) => {
  return <div className={`mb-6 ${className}`} data-id="element-23683">
      {title && <h3 className="text-lg font-bold text-transparent bg-clip-text bg-gradient-to-r from-gray-900 to-gray-700 dark:from-white dark:to-gray-300 relative inline-block mb-3" data-id="element-23684">
          {/* Title glow effect */}
          <span className="relative z-10" data-id="element-23685">{title}</span>
          <div className="absolute -bottom-1 left-0 right-0 h-[2px] bg-gradient-to-r from-purple-500/70 to-pink-500/70 rounded-full shadow-[0_0_8px_rgba(168,85,247,0.4)]" data-id="element-23686"></div>
        </h3>}
      {children}
    </div>;
};